<val-fiche-generique #ficheGenerique
                     [titre]="ficheContenu.donnees?.titre ?? ''"
                     (fermerClick)="Fermer()">
  <div menu>
    <val-barre-menus [menuItems]="menuItems()"></val-barre-menus>
  </div>
  <div contenu class="val-facture-vente-fiche-contenu">
    <val-facture-vente-fiche-contenu #ficheContenu></val-facture-vente-fiche-contenu>
  </div>
</val-fiche-generique>
